/**
 * Returns true when the React app is running inside the Electron shell.
 * Safe to call in browser too — returns false there.
 */
export function isElectron(): boolean {
  return typeof window !== 'undefined' && typeof window.electronAPI !== 'undefined';
}
